import { render, staticRenderFns } from "./SetupOtpConfirmPopup.vue?vue&type=template&id=d52c960e&scoped=true"
import script from "./SetupOtpConfirmPopup.vue?vue&type=script&lang=js"
export * from "./SetupOtpConfirmPopup.vue?vue&type=script&lang=js"
import style0 from "./SetupOtpConfirmPopup.vue?vue&type=style&index=0&id=d52c960e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52c960e",
  null
  
)

export default component.exports